import { ConnectWalletButtonProps } from './ConnectWalletButton.types';

export const defaultProps: Partial<ConnectWalletButtonProps> = {
  i18n: {
    connectLabel: 'connect wallet',
    unsupportedNetworkLabel: 'switch network',
  },
};
